export const NotificationConstants = {
   GET_NOTIFICATION_LIST_SUCCESS: "GET_NOTIFICATION_LIST_SUCCESS",
   GET_NOTIFICATION_LIST_FAILURE: "GET_NOTIFICATION_LIST_FAILURE"
}